module.exports = {
  menu: {
    logo: "MIM协同交付平台",
  },
  other: "其他",
  all: "全部",
  search_remind: "请输入搜索内容",
  search: "搜索",
  add_project: "添加项目",
  project_name: "项目名称",
  project_type: "项目类型",
  project_type_remind: "请选择项目类型",
  project_contracting: "工程承包",
  engineering_consulting: "工程咨询",
  engineering_design: "工程设计",
  planning_time: "计划时间",
  start_date: "开始日期",
  end_date: "结束日期",
  owner_name: "业主名称",
  address: "项目地址",
  progress: "项目进度",
  progress_remind: "请输入整数",
  introduction: "项目简介",
  upload_pictures: "上传项目图片",
  submit_upload: "点击上传",
  submit: "提交",
  upload: "上传",
  file: "文件",
  folder: "文件夹",
  new_folder: "新建文件夹",
  helpPart: "帮助",
  submitFeedback: "提交反馈",
  technologySupport: "技术支持",
  helpDocument: "帮助文档",
  instructionManual: "使用说明书",
  platformOverview: "平台概述",
  registrationAndExit: "注册、退出",
  projectManagement: "项目管理",
  fileManagement: "文档管理",
  drawingManagement: "图纸管理",
  MIMmodelManagement: "MIM模型管理",
  returnProject: "返回项目",
  user_center: "用户中心",
  logout: "退出",
  ok: "确 定",
  cancel: "取 消",
  edit: "编辑",
  edit_node_remind: "点击编辑对内容进行修改",
  delete: "删除",
  key_nodes: "关键节点",
  add_node: "增加节点",
  date: "日期",
  add_role: "添加角色",
  hint: "请输入需要创建的角色名",
  label_name: "角色名",
  role_manage: "管理角色",
  batch_edit_member_role: "批量修改成员角色",
  applications: "应用管理",
  content: "内容",
  my_content: "我的内容",
  content_remind: "请输入内容",
  operation: "操作",
  v_my_name: "我的姓名",
  v_email: "验证邮箱",
  email_code: "邮箱验证码",
  v_email_remind: "请输入验证码",
  get_v_email: "获取验证码",
  v_code: "该验证码将发送到验证邮箱中",
  v_code_sent_to: "该验证码将发送到",
  a1: "项目中已存在同名项目，若申请加入该项目请选择项目后点击'申请加入该同名项目'",
  a2: "申请加入该同名项目",
  enter_info: "确认信息",
  creator1: "创建人",
  drawing_size: "图纸大小",
  creator1_time: "创建日期",
  enfi: "中国矿业信息化协同创新北京市工程研究中心技术支持",
  enfi_add: "北京市海淀区复兴路12号",
  address2: "地址",
  contact_number: "联系电话",
  qq: "QQ 群",
  website_record_number: "网站备案号",
  // website_record_number_date:"京ICP备18055077号",
  website_record_number_date: "京ICP备18055077-1号",
  wechat_attention: "微信关注",
  xiaochengxu_attention: "小程序入口",
  download: "下载",
  launch_mission: "发起任务",

  routerMeta: {
    Survey: "概况",
    FileControl: "文档",
    DrawingManagement: "图纸",
    MimModel: "模型",
    ControlPage: "应用",
    oxygenPage: "氧气站",
    Case: "示例应用",
    MyApplication: "项目应用",
    Undeveloped: "任务管理",
    processManagement: "流程管理",
    process: "流程",
    formManagement: "表单管理",
    ProjectSettings: "设置",
    Information: "消息",

    ShareFile: "文档分享",
    Home: "系统首页",
    MimCaseTwo: "三维管控模型案例2",
    MimCaseThree: "三维管控模型案例3",
    MimCaseFive: "三维管控模型案例5",
    PreviewfileFormat: "图纸模型预览",
    ViewModel: "查看模型",
    ViewDrawing: "查看图纸",
    MimCaseOne: "西芒杜模型",
    MimCaseFour: "加载GIS环境",
    MimCaseSix: "设备管理",
    EnfiMeeting: "视频会议",
    MonomerModel: "单体模型",
    IntegratedModel: "集成模型",
    myProcess: "我的流程",
    upcomingTasks: "待办任务",
    doneTasks: "已办任务",
    EnfiNextcloud: "网盘",
    deliver: "交付",
    deliveryBasis: "交付基础",
    projectObject: "工程对象",
    dataReport: "数据报表",
    task: "任务",
    Upload: "交付数据",
    Definition: "流程定义",
    docManagement: "文件管理",
    relationManagement: "关联关系管理",
    searchPage: "搜索",
  },
  project_overview: "项目概况",
  // file_manage:"文档管理",
  // drawing_manage:"图纸管理",
  // mim_model:"MIM模型",
  // mim_app:"MIM应用",
  // task_manage:"任务管理",
  // project_set:"项目设置",
  my_tasks1: "我的待办任务",
  my_tasks2: "我的已办任务",
  my_tasks3: "我上传的文档",
  my_tasks4: "我的图纸",
  model_total: "模型总数",
  drawing_total: "图纸总数",
  file_total: "文档总数",
  members_total: "成员总数",
  project_members: "项目成员",
  id: "Id",
  name: "姓名",
  role: "角色",
  task_statistics: "任务统计",
  new_creation1: "新创建",
  establish: "创建",
  new_creation2: "进行中",
  new_creation3: "已完成",
  new_creation4: "已关闭",
  new_creation5: "网络错误",
  node_error: "查询节点信息失败",
  survey_error: "查询概况信息失败",
  application_examples: "示例应用",
  my_examples: "项目应用",
  roam: "场景自动漫游",
  interactive: "交互式MIM信息查询",
  simulation: "进度计划模拟",
  gis: "加载GIS环境",
  visualization: "设计方案可视化",
  device_m: "设备管理",
  RH_gis: "加载Gis地图",
  YQS_geo_resource: "地质资源模型",
  Safety_management: "安全管理",
  Schedule: "进度计划",
  Shovel_loader: "铲车运动",
  Shovel_btn1: "开启转盘",
  Shovel_btn2: "开启摇摆",
  Shovel_btn3: "开启跳跃并旋转",
  Shovel_btn4: "开启悬停",
  YQS_trans_system: "开拓运输系统",
  RoamingCase: "厂区漫游",
  start_roam: "开启自动漫游",
  pause_roam: "暂停自动漫游",
  show_project_info: "显示工程信息",
  hide_project_info: "隐藏工程信息",
  ramp: "斜坡道",
  main_shaft: "主井",
  auxiliary_shaft: "副井",
  air_intake_shaft: "进风井",
  return_air_shaft: "回风井",
  rail_trans_level: "有轨运输水平",
  pull_level: "拉底水平",
  ore_drawing_level: "出矿水平",
  close_twinkle: "关闭闪烁",
  crushing_station: "破碎站",
  monitoring: "实时监测预警",
  inspection: "可视化巡检记录",
  custom: "定制开发联系",
  open: "暂未开放",
  subitem_m: "子项管理",
  subitem: "子项",
  add_drawing: "添加图纸",
  b_delete: "批量删除",
  select_remind: "请勾选模型",
  BelongSub: "所属子项",
  a_delete: "批量授权",
  history_upload: "查看上传任务",
  upload_misssion: "上传任务",
  subitem_n: "子项名称",
  drawing: "图纸名称",
  drawing_format: "图纸格式",
  authority: "权限",
  version: "版本",
  updated_version: "更新版本",
  h_version: "历史版本",
  s_permissions: "设置权限",
  rename: "重命名",
  s_rename: "图纸重命名",
  remarks: "备注",
  updated_drawing: "更新图纸",
  drawings_documents: "图纸文件",
  preview_list: "可预览名单",
  add: "添加",
  role_or_person: "角色或人员",
  jurisdiction: "权限",
  preview: "预览",
  preview_people: "添加预览人员",
  subordinate: "所属子项",
  upload_drawings: "上传图纸",
  select_from: "从文档选取",
  file_name: "文件名",
  select_upload: "选择并上传",
  add_subitem: "添加子项",
  subitem_rename: "子项重命名",
  google: "为提高模型图纸浏览体验,推荐您使用EDGE浏览器",
  download_address: "下载地址",
  select_sub_item: "请选择图纸的子项",
  select_major_item: "请选择专业",
  successfully_deleted: "删除成功",
  authorization_successful: "添加成功",
  failed: "文件获取失败",
  wait: "正在上传，请稍等",
  please: "请先填写所属子项",
  cancel_deletion: "取消删除",
  subitem_success: "子项重命名成功！",
  subitem_success2: "子项添加成功",
  drawing_success: "图纸重命名成功",

  fill: "请将信息填写完",
  conversion_failed: "转换失败，请删除文件并重新确定格式后上传",
  lightweight: "正在进行轻量化处理",
  please_upload: "请上传图纸文件",
  model_success: "模型更新成功",
  drawing_upload_success: "图纸上传成功",
  format_allowed: "模型文件格式不允许,请重新上传",
  v_deleted_success: "版本删除成功！",
  failed_drawing: "图纸添加失败",
  deletion_canceled: "已取消删除",
  all_file: "全部文件",
  file_not_created: "未创建文件",
  favorites: "收藏夹",
  shared: "已分享",
  recycle_bin: "回收站",
  label: "标签",
  collection: "收藏",
  cancel_collection: "取消收藏",
  share: "分享",
  copy_move: "复制移动",
  tagging: "新增标签",
  confirm_deletion: "确认删除",
  file_size: "文件大小",
  creation_time: "创建时间",
  transformation: "转换",
  complete: "完成",
  label_setting: "标签设置",
  delete_restore: "删除/恢复",
  not_subfolders: "没有更多的子文件夹",
  copy: "复制",
  move: "移动",
  copy_to: "复制到",
  move_to: "移动到",
  move_to2: "请输入文件夹名称",
  set_label: "为该文件设置标签",
  please_2: "请选择",
  please_3: "选择标签颜色",
  please_4: "标签内容",
  reduction: "还原",
  select_12: "选择分享功能",
  select_13: "确认选择",
  compare_1: "选择其他版本与当前版本对比",
  link_sharing: "成功分享链接",
  copy_link: "复制链接",
  view_link: "查看链接",
  delete_link: "删除链接",
  file_name1: "请输入文件名",
  permission_list: "权限列表",
  modify1: "修改",
  authorize: "授权",
  add_permission1: "添加权限",
  select_permissions2: "选择权限",
  confirm_permissions3: "确认权限",
  select_file2: "选取文件",
  upload_to_server: "上传到服务器",
  select_folder2: "选择文件夹",
  add_model2: "添加模型",
  model_format: "模型格式",
  model_size: "模型大小",
  model_rename: "模型重命名",
  model_name: "模型名称",
  update_model2: "更新模型",
  model_file2: "模型文件",
  cover_image: "封面图片(可选)",
  share_model_links: "分享模型链接",
  model_link_created: "模型链接已创建",
  model_link: "模型链接",
  cancel_sharing: "取消分享",
  close: "关闭",
  my_role: "我的角色",
  // project_manager1:"项目管理员",
  add_members2: "添加成员",
  new_members3: "新增成员",
  serial_number: "序号",
  phone_number: "手机号码",
  select_role_type: "选择角色类型",
  design_manager: "设计经理",
  project_manager: "项目经理",
  progress_engineer: "进度工程师",
  professional_director: "专业负责人",
  main_designer: "主要设计者",
  owner: "业主",
  editorial_members: "编辑成员",
  project_information1: "项目信息",
  edit_node: "编辑节点",
  save: "保存",
  save_picture: "保存图片",
  download_check_box: "下载勾选项",
  go_back: "返回上一级",
  go_back12: "页面建设进行中",
  enter_version_list: "进入版本列表",
  return_drawing_list: "返回图纸列表",
  return_model_list: "返回模型列表",

  translation: "平移",
  rotate: "旋转",
  zoom_to_all: "缩放至全部",
  add_comments: "添加批注",
  box_selection: "框选",
  circular: "圆形",
  square: "正方形",
  words: "文字",
  re_annotate: "重新批注",
  comments: "批注",
  comment: "评论",
  comment_count: "评论数量",
  full_version: "全部版本",
  all_creators: "所有创建人",
  annotation_export: "导出批注至文档",
  i_create: "我创建的",
  export: "导出",
  create_an_annotation121: "您没有创建批注！",
  associated_files: "关联文件",
  associated_files12: "添加关联文件",
  share_drawing_links: "分享图纸链接",
  drawing_links: "图纸链接",
  share_drawings: "分享图纸",
  share_links: "分享链接",
  share_model: "分享模型",
  share_QR_code: "分享二维码",
  comment_area: "评论区",
  tips: "提示",
  delete_the_comment: "是否删除该评论 ?",
  wq_long: "文件正在处理中，首次预览需等待较长时间",
  case1_1: "自动漫游",
  case1_2: "暂停自动漫游",
  case1_3: "查看立式砂仓",
  case1_4: "查看搅拌装置",
  case1_5: "查看浓密机",
  case2_1: "显示加强支护巷道",
  case2_2: "隐藏加强支护巷道",
  case2_3: "显示紧急避险硐室",
  case2_4: "隐藏紧急避险硐室",
  case2_5: "显示通风效果",
  case2_6: "隐藏通风效果",
  case3_1: "显示生长动画",
  case4_1: "加载地图",
  case4_2: "隐藏地图",
  case4_3: "地图半透明",
  case4_4: "修改地图类型",
  case5_1: "显示运输提升方案",
  case5_2: "隐蔽运输提升方案",
  case5_3: "显示通风系统方案",
  case5_4: "隐藏通风系统方案",
  case5_5: "显示充填系统方案",
  case6_1: "查看",
  case6_2: "事故预警",
  RH_gis_btn1: "加载地图",
  RH_gis_radio1: "天地图影像地图",
  RH_gis_radio2: "天地图矢量地图",
  RH_gis_radio3: "高德影像地图",
  RH_gis_radio4: "高德道路地图",
  RH_gis_radio5: "必应地图",
  YQS_geo_btn1: "显示矿体信息",
  YQS_geo_btn2: "矿体剖切",
  YQS_geo_btn3: "显示剖切盒",
  YQS_geo_btn4: "重置",
  YQS_geo_title: "品位",
  existProject: "退出该项目",
  ModelExplosion: "模型爆炸",
  ME_botton: "模型爆炸",
  ME_botton_alert: "请拖动右侧进度条",
  favs: "收藏",
  tips123:
    "支持在线浏览的图纸模型格式：dwg, dxf, dwf, dwxf, rvt, dgn, rvm, ifc, nwd, fbx, 3ds, obj, dae,osgb,osgbzip,zip,skp,sldprt,mim",
  file_manage_tips:
    "支持轻量化浏览的图纸模型格式：dwg, dxf, dgn, rvm, ifc, fbx, 3ds, obj, dae, dwf,  dwxf；支持在线协同编辑的office文件：docx, pptx, xlsx, txt等",
  place_create_comments: "请输入批注描述",
  tips_model_message: "你还没有mim模型，赶快去创建一个吧",
  please_model_name: "请输入模型名称",
  please_remark_info: "请输入备注信息",
  version_info_require: "版本信息不能为空",
  set_success: "设置成功",
  storage_space_full: "存储空间已满",
  please_3d: "请上传三维模型!",
  please_images: "请上传图片格式!",
  model_rename_success: "模型重命名成功",
  please_model_file: "请上传模型文件!",
  model_add_success: "模型添加成功",
  model_add_faile: "模型添加失败",
  please_sub_name: "请输入子项名",
  please_name: "请输入名称",
  please_2d: "请上传二维图纸!",
  signIn: "登录",
  model: "模型",
  total: "总数",
  my: "我的",
  drawings: "图纸",
  setUp: "设置",
  converting_progress: "转换中",
  document_control_manager: "文控经理",
  subItem_require: "请填写子项",
  subItem_name: "子项名称",
  project_management: "项目容量",
  model_n: "模型名称",
  modelFormat: "模型格式",
  permissionSource: "权限来源",
  select_wj_share: "确认分享",
  select_wj_cancel: "删除已分享",
  sourceDict: {
    inherit: "继承权限",
    empower: "用户授权",
    creator: "目录创建者",
  },
  project_journal: "项目日志",
  app_name: "应用名称",
  status: "状态",
  NewIntegration: "新建集成",
  model_drawing_repeat: "上传文件重复",
  upload_cover_type: "上传封面类型",
  picture: "图片",
  upload_project_model: "上传项目模型",
  expiration_time: "过期时间",
  drawing_comparison: "图纸对比",
  process_management: "流程定义",
  new_file: "新建文件",
  directory_tree: "目录树",
  object_detail: "构件详情",
  no_data: "暂无数据",
  object_warning: "请选择一个构件，以查看对应属性",
  loadMode: "加载模式",
  fail: "失败",
  new: "新建",
  major_manage: "专业管理",
  management: "管理",
  major_name: "专业名称",
  add_major: "添加专业",
  rename_major: "重命名专业",
  major: "所属专业",
  application_setting: "应用设置",
  decompression: "解压",
  weChat_binding: "微信绑定",
  clear_cache: "清理缓存",
  preview_sharing: "查看分享",
  problem_feedback: "问题反馈",
  platform_Introduction: "平台简介",
  linkage: "联动",
};



// WEBPACK FOOTER //
// ./src/assets/lang/zh.js